import options from './thing-details-labels.component';

export default {
    selector: 'dtThingDetailsLabels',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-labels/index.js